import { Alert, Fade, Snackbar } from "@mui/material";
import { useContext } from "react";
import { useState, createContext, useCallback } from "react";

const ToastContext = createContext();

export function ToastContextProvider({ children }) {
  const [state, setState] = useState({open: false, message: "", type: "info"});

  const showToast = useCallback((type, message) => {
    setState({ open: true, message, type})
  }, [setState]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setState({
      ...state,
      open: false,
    });
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Snackbar
        TransitionComponent={Fade}
        open={state.open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ width: "50%" }}
      >
        <Alert variant="filled" onClose={handleClose} severity={state.type} sx={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}>
          {state.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  )

}

export default function useToastNotification() {
  return useContext(ToastContext);
};